module.exports = __webpack_public_path__ + "img/scene5-1.5eff89ab.jpg";